import * as React from 'react';
import { isFrameworkFeatureEnabled } from 'owa-feature-flags';
import toggleDarkModeThemeAction from './actions/toggleDarkModeTheme';
import getIsDarkModeEnabledInUserSettings from './selectors/getIsDarkModeEnabledInUserSettings';
import DarkModeFull from './components/DarkModeFull';
import saveDarkModeOption from './orchestration/saveDarkModeOption';
import discardDarkModeOption from './orchestration/discardDarkModeOption';
import getIsFullOptionDirty from './selectors/getIsFullOptionDirty';
import { isCssVariablesSupported } from 'owa-theme';
var DarkModeOption = {
    key: 'darkMode',
    titleStringKey: 'options_theme_darkmode_toggle',
    searchTermsStringKey: 'options_theme_darkmode_toggle',
    fullOptionFormSettings: {
        render: function () { return React.createElement(DarkModeFull, null); },
        isDirty: getIsFullOptionDirty,
        onSave: saveDarkModeOption,
        onDiscard: discardDarkModeOption,
    },
    quickOptionSettings: {
        rendering: {
            isToggleOn: getIsDarkModeEnabledInUserSettings,
            onToggle: toggleDarkModeThemeAction,
            isDisabled: function () { return !isCssVariablesSupported(); },
        },
        order: 1 /* DarkMode */,
        workloads: 2415919103 /* All */,
        tooltip: {
            tooltipStringKey: function () {
                return isCssVariablesSupported()
                    ? 'theme_dark_mode_some_themes_unavailable'
                    : 'theme_dark_mode_unavailable';
            },
        },
    },
    isHidden: function () {
        return !(isFrameworkFeatureEnabled('fwk-darkTheme') &&
            isFrameworkFeatureEnabled('fwk-useCssVariables'));
    },
};
export default DarkModeOption;
//# sourceMappingURL=DarkModeOption.js.map